
/** 混入方法 ::: 
 *  @mixin mixRiceIndexCommon 表单编辑组件公共部分混入
 *  @mixin mixFormItemTemplateProtocolRealize 协议实现混入
 *  @mixin mixDomainManager 模块组件管理者混入
 *  @mixin mixFormNodeManager 表单节点管理者混入
 *  @mixin mixFormListManager 表单列表管理者混入
 *  @mixin mixDomainEditManager 模块编辑管理者混入
 *  @mixin mixMakeConfigManager 生成配置管理者混入
 *  @mixin mixFormConfigManager 表单配置管理者混入
 *  @mixin mixEventConfigManager 时间配置管理者混入
 *  @mixin mixFormExhibitsManager 展示表单项管理者混入
 *  @mixin mixEventEditConfigManager 事件编辑管理者混入
 */
import { mixRiceIndexCommon } from "@/mixins/rice_index/mix_rice_index_common.js";
import { mixFormItemTemplateProtocolRealize } from "@/mixins/rice_index/mix_rice_index_protocol_realize.js";
import { mixDomainManager } from "@/mixins/common/mix_domain_manager.js"
import { mixFormNodeManager } from "@/mixins/common/mix_form_node_manager.js";
import { mixFormListManager } from "@/mixins/common/mix_form_list_manager.js";
import { mixDomainEditManager } from "@/mixins/common/mix_domain_edit_manager.js";
import { mixMakeConfigManager } from "@/mixins/common/mix_make_config_manager.js";
import { mixFormConfigManager } from "@/mixins/common/mix_form_config_manager.js";
import { mixEventConfigManager } from "@/mixins/common/mix_event_config_manager.js";
import { mixFormExhibitsManager } from "@/mixins/common/mix_form_exhibits_manager.js";
import { mixEventEditConfigManager } from "@/mixins/common/mix_event_edit_config_manager.js";


/** @name RiceIndex.vue 混入
 *  @author 王汝鹏
 *  @version 2019-09-16
 */
export const mixRiceIndex = {
  mixins: [ 
    mixRiceIndexCommon,
    mixDomainManager,
    mixFormNodeManager,
    mixFormListManager,
    mixMakeConfigManager,
    mixDomainEditManager,
    mixFormConfigManager,
    mixEventConfigManager,
    mixFormExhibitsManager,
    mixEventEditConfigManager,
    mixFormItemTemplateProtocolRealize 
  ],
  provide() { return { mix_rice_index_store: this.mix_rice_index_store } },
  data() {
    return {
      /** mix_rice_index_store 属性说明 ::: 
       *  - activeNode: 激活表单项
       *  - activeList: 激活表单项的父级
       *  - formList: 拖拽区的所有表单数据
       *  - formSettingState: 表单属性设置集合
       *  - formMap: 表单项字典 { formId: 表单项配置对象 }
       *  - eventMap: 事件字典 { 事件id: 事件配置 }
       *  - domainList: 模块列表 Array<{ id:1, name:"甲方出卖人", icon:"iconlayout" }>
       *  - domainEditProcess: 模块编辑过程记录
       *  - - domain: 模块组件对象
       *  - - original: 修改前备份数据
       *  - - status: 修改状态 { normal:正常状态, editing:修改中状态, changed:已经发生改动状态 }
       *  - - operation: 操作类型 { none:无操作, templates:模版操作, name:名称操作 }
       *  - expandFunction: 扩展功能 { none:不启用任何扩展功能, group:启用分组管理功能 }
       *  - variableMap: 变量设置字典
       */
      mix_rice_index_store: {
        activeNode: {},
        activeList: [],
        formList: [],
        domainList: [],
        formMap: {},
        eventMap: {},
        formSettingState: { componentSize: 'mini' },
        domainEditProcess: {
          domain: null,
          original: {},
          status: "normal",
          operation: "none"
        },
        expandFunction: 'none',
        variableMap: {}
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/rice_index/mix_rice_index.js